import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { getSubscriptionStatus, getPaymentHistory } from "../services/Api";
import "../css/Profile.css";

const ProfileAbo = ({ token }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [status, setStatus] = useState(null);
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [statusData, historyData] = await Promise.all([
          getSubscriptionStatus(token),
          getPaymentHistory(token),
        ]);
        setStatus(statusData);
        setPayments(historyData.payments || []);
      } catch (err) {
        console.error(err);
        setError("Impossible de récupérer les informations d'abonnement.");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [token]);

  const formatDate = (isoString) => {
    if (!isoString) return "—";
    return new Date(isoString).toLocaleDateString("fr-FR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  const formatAmount = (amountInCents, currency = "EUR") =>
    new Intl.NumberFormat("fr-FR", { style: "currency", currency }).format(
      (amountInCents || 0) / 100
    );

  if (loading) return <div className="abo-section">{t("profile.abo.loading", "Chargement…")}</div>;
  if (error) return <div className="abo-section abo-error">{error}</div>;

  return (
    <div className="abo-section">
      <h2>{t("profile.abo.title", "Mon abonnement")}</h2>

      <div className="abo-status-card">
        <span className={`abo-badge ${status.active ? "abo-badge-active" : "abo-badge-inactive"}`}>
          {status.active ? t("profile.abo.active", "Actif") : t("profile.abo.inactive", "Inactif")}
        </span>

        {status.role === "admin" ? (
          <p>{t("profile.abo.admin", "Accès illimité (compte administrateur).")}</p>
        ) : status.expireDate ? (
          <p>
            {status.active
              ? t("profile.abo.expiresOn", "Votre accès expire le")
              : t("profile.abo.expiredOn", "Votre accès a expiré le")}{" "}
            {formatDate(status.expireDate)}
          </p>
        ) : (
          <p>{t("profile.abo.none", "Aucun abonnement actif.")}</p>
        )}

        {!status.active && status.role !== "admin" && (
          <button className="abo-cta" onClick={() => navigate("/subscribe")}>
            {t("profile.abo.subscribe", "S'abonner")}
          </button>
        )}
      </div>

      <h3>{t("profile.abo.historyTitle", "Historique des paiements")}</h3>

      {payments.length === 0 ? (
        <p>{t("profile.abo.noHistory", "Aucun paiement enregistré.")}</p>
      ) : (
        <table className="abo-history-table">
          <thead>
            <tr>
              <th>{t("profile.abo.date", "Date")}</th>
              <th>{t("profile.abo.description", "Description")}</th>
              <th>{t("profile.abo.amount", "Montant")}</th>
              <th>{t("profile.abo.status", "Statut")}</th>
            </tr>
          </thead>
          <tbody>
            {payments.map((p) => (
              <tr key={p._id}>
                <td>{formatDate(p.paidAt)}</td>
                <td>{p.description || "—"}</td>
                <td>{formatAmount(p.amount, p.currency)}</td>
                <td>
                  <span className={`abo-payment-status abo-payment-${p.status}`}>
                    {t(`profile.abo.paymentStatus.${p.status}`, p.status)}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default ProfileAbo;